import React from "react";
import "./stars.css";

const stars3 = () => {
  return (
    <div className="stars">
      <div className="inner one"></div>
      <div className="inner two"></div>
      <div className="inner three"></div>
    </div>
  );
};

export default stars3;
